import styled from 'styled-components'
import { theme } from '@superhi/design'

export const LineItems = styled.div`
  > *:not(:last-child) {
    border-bottom: 1px solid ${theme.colors.GREY_60};
    padding-bottom: 16px;
    margin-bottom: 16px;
  }
`
